"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _commonReact = require("@devsta/common-react");

var _lodash = _interopRequireDefault(require("lodash.debounce"));

var _classnames = _interopRequireDefault(require("classnames"));

var _moment = _interopRequireDefault(require("moment"));

var _uiKit = require("@devsta/ui-kit");

require("../styles/_add-posts-modal.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var AddPostsModal = /*#__PURE__*/function (_Component) {
  _inherits(AddPostsModal, _Component);

  function AddPostsModal(props) {
    var _this;

    _classCallCheck(this, AddPostsModal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AddPostsModal).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onChangeSearch", (0, _lodash.default)(function (_ref) {
      var value = _ref.target.value;

      _this.setState({
        searchTerm: value
      }, _this.fetchData);
    }, 200));

    _defineProperty(_assertThisInitialized(_this), "fetchData", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var getInspirations, searchTerm, _ref3, data, error;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              getInspirations = _this.props.getInspirations;
              searchTerm = _this.state.searchTerm;
              _context.next = 4;
              return getInspirations({
                searchTerm: searchTerm,
                limit: 4
              });

            case 4:
              _ref3 = _context.sent;
              data = _ref3.data;
              error = _ref3.error;

              if (!(!data || error || !data.getInspirations)) {
                _context.next = 9;
                break;
              }

              return _context.abrupt("return");

            case 9:
              _this.setState({
                posts: data.getInspirations
              });

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "addPost", function (postId) {
      return function () {
        var campaignId = _this.props.campaignId;
        var _this$state = _this.state,
            postOverrides = _this$state.postOverrides,
            posts = _this$state.posts;
        if (!posts) return;
        var selectedIndex = postOverrides.findIndex(function (override) {
          return postId === override.inspirationId;
        });

        var _ref4 = posts.find(function (post) {
          return post.inspirationId === postId;
        }) || {},
            campaign = _ref4.campaign;

        var _ref5 = campaign || {},
            inspirationCampaignId = _ref5.inspirationCampaignId;

        if (selectedIndex < 0) {
          return void _this.setState({
            postOverrides: [].concat(_toConsumableArray(postOverrides), [{
              inspirationId: postId,
              added: campaignId !== inspirationCampaignId,
              originalCampaignId: inspirationCampaignId
            }])
          });
        }

        var newAdded = _toConsumableArray(postOverrides);

        newAdded.splice(selectedIndex, 1, {
          inspirationId: postId,
          added: !postOverrides[selectedIndex].added,
          originalCampaignId: inspirationCampaignId
        });

        _this.setState({
          postOverrides: newAdded
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this), "handleSave", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var postOverrides, _this$props, campaignId, updateInspirations, hideModal, onAddPosts, payload, _ref10, _ref11, _ref11$, addData, addError, _ref11$2, removeData, removeError;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              postOverrides = _this.state.postOverrides;
              _this$props = _this.props, campaignId = _this$props.campaignId, updateInspirations = _this$props.updateInspirations, hideModal = _this$props.hideModal, onAddPosts = _this$props.onAddPosts;
              payload = postOverrides.filter(function (_ref7) {
                var added = _ref7.added,
                    originalCampaignId = _ref7.originalCampaignId;
                return !added && originalCampaignId === campaignId || added && originalCampaignId !== campaignId;
              }).reduce(function (_ref8, _ref9) {
                var additions = _ref8.additions,
                    removals = _ref8.removals;
                var added = _ref9.added,
                    inspirationId = _ref9.inspirationId;
                return {
                  additions: added ? [].concat(_toConsumableArray(additions), [inspirationId]) : additions,
                  removals: added ? removals : [].concat(_toConsumableArray(removals), [inspirationId])
                };
              }, {
                additions: [],
                removals: []
              });
              _context2.next = 5;
              return Promise.all([updateInspirations({
                inspirationIds: payload.additions,
                input: {
                  inspirationCampaignId: campaignId
                }
              }), updateInspirations({
                inspirationIds: payload.removals,
                input: {
                  inspirationCampaignId: null
                }
              })]);

            case 5:
              _ref10 = _context2.sent;
              _ref11 = _slicedToArray(_ref10, 2);
              _ref11$ = _ref11[0];
              addData = _ref11$.data;
              addError = _ref11$.error;
              _ref11$2 = _ref11[1];
              removeData = _ref11$2.data;
              removeError = _ref11$2.error;

              if (!(!addData || !removeData || addError || removeError)) {
                _context2.next = 15;
                break;
              }

              return _context2.abrupt("return");

            case 15:
              if (onAddPosts) {
                onAddPosts();
              }

              if (hideModal) {
                hideModal();
              }

            case 17:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _this.state = {
      postOverrides: [],
      posts: void 0
    };
    return _this;
  }

  _createClass(AddPostsModal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref12) {
      var prevVisible = _ref12.visible;
      var thisVisible = this.props.visible;

      if (!prevVisible && thisVisible) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          postOverrides: []
        }, this.fetchData);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          visible = _this$props2.visible,
          hideModal = _this$props2.hideModal,
          campaignId = _this$props2.campaignId;
      var _this$state2 = this.state,
          posts = _this$state2.posts,
          postOverrides = _this$state2.postOverrides;

      if (!posts) {
        return null;
      }

      return _react.default.createElement("div", {
        className: "add-posts-to-campaign-modal"
      }, _react.default.createElement(_uiKit.FormModal, {
        visible: visible,
        onClose: hideModal,
        title: "Add Inspiration Posts",
        onSave: this.handleSave,
        saveText: "SAVE CHANGES",
        stayOpenOnSave: true
      }, _react.default.createElement("div", {
        className: "add-posts-to-campaign-modal__content"
      }, !posts.length ? _react.default.createElement("p", {
        className: "add-posts-to-campaign-modal__content__empty"
      }, "No Inspiration posts found in this library.") : _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_uiKit.Input, {
        small: true,
        prefix: "search",
        placeholder: "Search Posts",
        onChange: this.onChangeSearch
      }), _react.default.createElement("div", {
        className: "add-posts-to-campaign-modal__content__posts"
      }, posts && posts.map(function (_ref13) {
        var inspirationId = _ref13.inspirationId,
            title = _ref13.title,
            updatedAt = _ref13.updatedAt,
            thumbnailUrl = _ref13.thumbnailUrl,
            postCampaign = _ref13.campaign;

        var _ref14 = postCampaign || {},
            inspirationCampaignId = _ref14.inspirationCampaignId,
            name = _ref14.name;

        var postOverride = postOverrides.find(function (_ref15) {
          var overrideId = _ref15.inspirationId;
          return overrideId === inspirationId;
        });
        var isAdded = postOverride ? postOverride.added : inspirationCampaignId === campaignId;
        return _react.default.createElement(_commonReact.Form.TitledFormBlock, {
          key: inspirationId,
          itemImage: thumbnailUrl,
          defaultImage: "guide",
          className: (0, _classnames.default)({
            'add-posts-to-campaign-modal__content__posts__post--unselected': !isAdded
          })
        }, _react.default.createElement(_commonReact.Form.FormBlockDescription, {
          buttonText: isAdded ? 'REMOVE' : 'ADD POST',
          name: title,
          onClickButton: _this2.addPost(inspirationId),
          description: [(0, _moment.default)(updatedAt).format('DD/MM/YYYY [at] hh:mma'), name ? _react.default.createElement("span", {
            className: "add-posts-to-campaign-modal__content__posts__post__campaign"
          }, _react.default.createElement(_uiKit.Icon, {
            name: "prevpage",
            size: 10,
            color: "nevada"
          }), name) : null],
          isPrimaryButton: !isAdded,
          highlightedName: isAdded
        }));
      }))))));
    }
  }]);

  return AddPostsModal;
}(_react.Component);

exports.default = AddPostsModal;